module.exports = __webpack_public_path__ + "static/media/nbc.650de1b2.svg";